module.exports = __webpack_public_path__ + "img/license.2380596d.png";